import { createContext } from 'react';
import { type CurrentUserDataFragment } from '../../../api/fragments/CurrentUserData';
import { type useGetAuthenticatedUserLazyQuery } from '../../../api/queries/getAuthenticatedUser';
import { type Maybe } from '../../../api/types';

export type AccountContextType = {
    token?: string | null;
    data: Maybe<CurrentUserDataFragment>;
    refetch: ReturnType<typeof useGetAuthenticatedUserLazyQuery>['0'];
    login: (token: string, userData: CurrentUserDataFragment) => void;
    logout: () => void;
};

export const AccountContext = createContext<AccountContextType | null>(null);
